<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import AccountSection from './account-section.vue'
import { accountMobileMenus } from '~/resources/account/account-dashboard'
import ModalAddBankAccount from '~common/account/modal-add-bank-account.vue'
import { ACCOUNT_PATH } from '~/constants'

const router = useRouter()
const currentTab = computed(() => {
  return accountMobileMenus.find(item => item.key === router.currentRoute.value?.query?.tab)
})
</script>

<template>
  <ClientOnly>
    <div class="page-account">
      <AccountSection v-if="router.currentRoute.value.fullPath === ACCOUNT_PATH" />
      <div v-if="currentTab?.component" class="page-wrapper__right--content">
        <component :is="currentTab.component" />
      </div>
      <ModalAddBankAccount />
    </div>
  </ClientOnly>
</template>

<style lang="scss" scoped>
@import '~scssAsset/mobile/pages/account/index.scss';
</style>
